import { useEffect, useState } from "react";
import { HOME_CRUMB, AUTHOR_CRUMB } from "../../constants/BreadcrumConstants";
import { AUTHOR_BIO } from "../../constants/PageTitleConstants";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import { AuthorBioBtns } from "./AuthorBioBtns";
import { makeGetRequest } from "../../rest/RestService";
import { AUTHOR_BIO_URL } from "../../constants/APIEndpointConstants";
import { useLocation } from "react-router-dom";
import { Loader } from "../general/Loader";
import { Helmet } from "react-helmet";
import { sanitizeHTML } from "../../helper/SanitizeHTML";
import { useSelector } from "react-redux";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import { useHistory } from "react-router";
import { ManageScroll } from "../../helper/ManageScroll";
import PageNotFound from "../not-found/PageNotFound";

const AuthorBio = () => {
  const location = useLocation();
  const [bio, setBio] = useState({});
  const history = useHistory();
  const { hfData, error: hfError } = useSelector((state) => state.hfReducer);
  const [loader, setLoader] = useState(true);
  const author_slug = new URLSearchParams(location.search).get("author_slug");
  useEffect(() => {
    setLoader(true);
    if (hfData?.header) {
      makeGetRequest(`${AUTHOR_BIO_URL}${author_slug}`)
        .then((res) => setBio(res.data?.author_bio))
        .catch((err) => setBio({ message: err.message }))
        .finally(() => {
          setLoader(false);
          ManageScroll(history);
        });
    }
  }, [location.search, author_slug, history, hfData?.header]);
  const classDescription =
    bio?.author_image !== "" && bio?.author_image
      ? "col-xs-12 col-sm-8 col-md-8 col-lg-8"
      : "col-xs-12 col-sm-12 col-md-12 col-lg-12";
      
  const ogURL = `${process.env.REACT_APP_FRONT_URL}${location.pathname}${location.search}`;
  const ogImage = process.env.REACT_APP_POLITY_IMAGE;
  const description = bio?.content;
  const pinTitleString = `${description?.replace(/(<([^>]+)>)/ig, '')}`;
  const socialDesc = pinTitleString?.split('.')?.[0];
  return (
    <>
      {loader ? (
        <Loader />
      ) : bio?.title && !hfError ? (
        <>
          <Helmet>
            <title>{AUTHOR_BIO}</title>
            <meta property="og:type" content="website" />
            <meta property="og:title" content={bio?.title} />
            <meta property="og:url" content={ogURL} />
            <meta property="og:image" content={bio?.author_image || ogImage} />
            <meta property="og:image:secure_url" content={bio?.author_image || ogImage} />
            <meta property="og:image:alt" content={socialDesc} />
            <meta property="og:description" content={socialDesc}></meta>
            <meta name="description" content={socialDesc}></meta>
            <meta property="og:site_name" content="Polity" />
          </Helmet>
          <Header data={hfData} />
          <div
            className="container-fluid subject_bg"
            style={{ paddingBottom: "0px" }}
          >
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="container subject_padding">
                  <Breadcrumb
                    crumbs={[
                      HOME_CRUMB,
                      AUTHOR_CRUMB,
                      { title: `${bio?.title}` },
                    ]}
                  />
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 subject_intro_text">
                      <div className="row author_blog_page">
                        {bio?.author_image && bio?.author_image !== "" && (
                          <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                            <div className="author_image_blog">
                              <img
                                className="slider_shadow"
                                alt={bio?.title}
                                title={bio?.title}
                                src={bio?.author_image}
                              />
                              <AuthorBioBtns
                                bookUrl={bio?.view_book_url}
                                blogUrl={bio?.read_blog_url}
                                author_slug={author_slug}
                              />
                            </div>
                          </div>
                        )}
                        <div className={classDescription}>
                          <div className="author_description_content">
                            <h1 className="author_desc_title">{bio?.title}</h1>
                            <p
                              style={{ border: "solid red 0px" }}
                              dangerouslySetInnerHTML={sanitizeHTML(
                                bio?.content
                              )}
                            />
                          </div>
                          {(!bio?.author_image || bio?.author_image === "") && (
                            <AuthorBioBtns
                              bookUrl={bio?.view_book_url}
                              blogUrl={bio?.read_blog_url}
                              author_slug={author_slug}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer data={hfData} />
        </>
      ) : (
        <>
          <PageNotFound pageError={bio?.message || hfError} />
        </>
      )}
    </>
  );
};
export default AuthorBio;
